import { Injectable, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
    AZ_MENU_METRIC_KEY,
    ESOCCER_METRIC_KEY,
    LDFeatureFlags,
    LaunchDarklyFlagManagerService,
    LaunchDarklyTrackingService,
} from '@frontend/sports/launch-darkly/feature';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UpSellCrossSellLDService {
    private launchDarklyFlagService = inject(LaunchDarklyFlagManagerService);
    private launchDarklyTrackingService = inject(LaunchDarklyTrackingService);
    readonly eSoccerOnAZMenuEnabled: Signal<boolean>;

    constructor() {
        this.eSoccerOnAZMenuEnabled = toSignal(
            this.launchDarklyFlagService.activateExperiment$(LDFeatureFlags.ESoccerInAZMenu).pipe(map((data) => data?.value)),
            { initialValue: false },
        );
    }

    trackUserVisitToAZMenu(): void {
        this.launchDarklyTrackingService.trackByContext(LDFeatureFlags.ESoccerInAZMenu, AZ_MENU_METRIC_KEY, 1, 1);
    }

    trackUserClickOnESoccer(): void {
        this.launchDarklyTrackingService.trackByContext(LDFeatureFlags.ESoccerInAZMenu, ESOCCER_METRIC_KEY, 1, 1);
    }
}
